import useAppSelector from "~/hooks/use-app-selector.ts";
import StatusMainPanel from "~/components/ui/status-main-panel.tsx";
import LoadingAnimation from "~/components/ui/loading-animation.tsx";
import { isOnceOffError, isOnceOffNotComplete } from "~/utils/loading.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import { selectSystemPaletteLoad } from "./selectors.ts";

function PaletteLoadStatus() {
	const load = useAppSelector(selectSystemPaletteLoad);
	const t = useTranslator();

	return (
		<StatusMainPanel>
			{isOnceOffNotComplete(load) && (
				<LoadingAnimation>{t("Loading bricks...")}</LoadingAnimation>
			)}
			{isOnceOffError(load) && (
				<div className="form-error">
					{t("Error loading bricks")}: {load.message}
				</div>
			)}
		</StatusMainPanel>
	);
}

export default PaletteLoadStatus;
